import React from "react";
import { Spin } from "antd";
import { useLoadingStore } from "../../stores/loadingStore";
import "./styles.less";

interface GlobalLoadingProps {
  size?: "small" | "default" | "large";
  tip?: string;
  className?: string;
  variant?: "default" | "auth";
}

const GlobalLoading: React.FC<GlobalLoadingProps> = ({
  size = "large",
  tip = "Đang tải...",
  className = "",
  variant = "default",
}) => {
  const isAnyLoading = useLoadingStore((state) => state.isAnyLoading());

  if (!isAnyLoading && variant === "default") {
    return null;
  }

  if (variant === "auth") {
    return (
      <div className={`auth-loading ${className}`}>
        <div className="auth-loading-backdrop" />
        <div className="auth-loading-content">
          {/* Animated Loading Circle */}
          <div style={spinnerContainerStyle}>
            <div style={spinnerStyle}></div>
          </div>
          <div className="auth-loading-text">
            <h3>Đang kiểm tra đăng nhập</h3>
            <p>Vui lòng đợi trong giây lát...</p>
          </div>
          <div className="loading-progress">
            <div className="progress-bar"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`global-loading ${className}`}>
      <div className="global-loading-backdrop" />
      <div className="global-loading-spinner">
        <Spin size={size} tip={tip} />
      </div>
    </div>
  );
};

export default GlobalLoading;

const spinnerContainerStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  marginBottom: "24px",
};

const spinnerStyle: React.CSSProperties = {
  width: "60px",
  height: "60px",
  border: "4px solid #f0f0f0",
  borderTop: "4px solid #e91e63",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};
